import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../components/typography';
import InsertRemoveCard from '../../icons/caesars/insert-remove-card';
import Card from '../../icons/caesars/card';
import ScanBarcode from '../../icons/caesars/scan-barcode';
import { GreenText, Or, RedText, VerticalLine } from '../components';

export default function Kiosk() {
  return (
    <Container>
      <Text size="lg" weight="bold" style={{ width: '16.6rem' }}>
        <GreenText>Insert</GreenText> then <RedText>remove</RedText> your card in the slot below to activate.
      </Text>
      <Or />
      <Text size="lg" weight="bold" style={{ width: '18rem' }}>
        Enter the number shown on your Caesars Rewards® card.
      </Text>
      <Or />
      <Text size="lg" weight="bold" style={{ width: '22rem' }}>
        Open the Caesars Rewards® app and scan the barcode shown to activate.
      </Text>

      <InsertRemoveCard />
      <VerticalLine />
      <Card style={{ alignSelf: 'center' }} />
      <VerticalLine />
      <ScanBarcode />
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  padding: 3rem;
  gap: 3rem;
  grid-template-columns: 1fr 32px 1fr 32px 1fr;
  grid-template-rows: 7rem auto;
  justify-items: center;
`;
